export enum eCommentScope {
  internal = 'internal',
  external = 'external',
  vendor = 'vendor',
}
